import React from "react";
import "./Intro.scss";

const Intro = () => {
  return (
    <section className="intro-homepage">
      <div className="intro-homepage-wrapper">
        <div className="intro-text-homepage">
          <h1>Pendekatan Kirmago</h1>
          <p>Apa Itu Kirmago, Tujuan Kirmago Berdiri, hingga Jadwal Kirmago</p>
          <span>! pilih dan klik box untuk melihat keterangan</span>
        </div>
        <div className="intro-box-homepage-wrapper">
          <div className="intro-box-homepage">
            <img
              className="sirkel1"
              src="https://telegra.ph/file/fa8cb7df99ca90618271a.png"
              alt="source"
            />
            <img
              src="https://telegra.ph/file/610fa8d9f27416c149643.png"
              alt="source"
            />
            <h3>Apasih Kirmago itu?</h3>
          </div>
          <div className="intro-box-homepage">
            <img
              className="sirkel2"
              src="https://telegra.ph/file/fa8cb7df99ca90618271a.png"
              alt="source"
            />
            <img
              src="https://telegra.ph/file/d73d2d366731a833634b1.png"
              alt="source"
            />
            <h3>Tujuan Kirmago didirikan?</h3>
          </div>
          <div className="intro-box-homepage">
            <img
              src="https://telegra.ph/file/92e4bfdcfbde23ade305f.png"
              alt="source"
            />
            <h3>Jadwal Latihan Kirmago?</h3>
          </div>
        </div>

        <div className="intro-sejarah-wrapper">
          <p>
            Untuk melihat sejarah kirmago dan siapa sajakah alumni kirmago mulai
            awal berdirinya kirmago hingga sekarang {new Date().getFullYear()}{" "}
            tekan tombol disamping
          </p>
          <button>Wikipedia Kirmago</button>
        </div>
      </div>
      <div className="flat-sirkel">
        <img
          src="https://telegra.ph/file/e858e8148890b7a5dd620.png"
          alt="source"
        />
      </div>
    </section>
  );
};

export default Intro;
